import flagKeys from '@/constants/flagKeys';
import Dashboard from '@/views/Dashboard/Dashboard.vue';
import { Route } from '../route.model';

const allActivities = new Route('/activity', 'dashboard', Dashboard, {
  requiresAuth: true,
  isResponsive: flagKeys.responsiveDashboard,
  flag: flagKeys.legacyReports,
  zendesk: {
    mobile: {
      offsetHorizontal: '4px',
      offsetVertical: '4px'
    }
  },
  navbar: {
    name: 'All Activities', // TODO apply i18n
    icon: 'activities'
  }
});

export { allActivities };
export default allActivities;
